import type { WorkOrderVersionListItem, BimWorkOrderVersionListItem } from 'gql/graphql';
import { cnMixSpace, Combobox, SelectItem } from 'uikit';

import type React from 'react';
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import './SelectVersionsWorkOrder.css';
import { getWorkOrderVersionListItems } from '../../pages/Project/Common/utils';

interface ISelectVersionsWorkOrder {
    items?: WorkOrderVersionListItem[] | BimWorkOrderVersionListItem[];
}

export const SelectVersionsWorkOrder: React.FC<ISelectVersionsWorkOrder> = (props) => {
    const navigate = useNavigate();
    const { items } = props;

    const modifiedItems = useMemo(() => getWorkOrderVersionListItems(items), [items]);

    const defaultPlaceholder = useMemo(() => modifiedItems?.[0]?.labelWithoutChangeNumber, [modifiedItems]);

    const handleChangeSelect = useCallback(
        ({ value }) => {
            navigate(`./version/${value.id}`);
        },
        [navigate],
    );

    if (!items) {
        return null;
    }

    return (
        <Combobox
            placeholder={defaultPlaceholder}
            items={modifiedItems}
            onChange={handleChangeSelect}
            size="s"
            disabled={!modifiedItems?.length}
            className={cnMixSpace({ mR: 'xs' })}
            style={{ maxWidth: '192px' }}
            renderItem={({ item, active, hovered, onClick, onMouseEnter }) => (
                <SelectItem
                    label={item.labelWithoutChangeNumber}
                    active={active}
                    hovered={hovered}
                    onMouseEnter={onMouseEnter}
                    onClick={onClick}
                    multiple={false}
                    size="s"
                    indent="normal"
                    disabled={false}
                />
            )}
        />
    );
};

SelectVersionsWorkOrder.displayName = 'SelectVersionsWorkOrder';
